import React from "react";
import { connect } from "react-redux";
import "../../../../../scss/Hud/center/information/scene0start/start.scss";

const StartInfo = ({ languageSet, scrollDownInfo }) => {
  return (
    <div>
      <div id="startCenteredText">
        <div>
        <div>
          {languageSet === "en" ? "👋 𝑯𝒆𝒚 𝒚'𝑨𝒍𝒍, 𝑻𝒉𝒊𝒔 𝒊𝒔 𝑷𝒓𝒂𝒃𝒊𝒕𝒉 𝑮𝑺 😊" : null}
          {languageSet === "pl" ? "👋 𝑯𝒆𝒋 𝒘𝒚 𝒘𝒔𝒛𝒚𝒔𝒄𝒚, 𝒕𝒐 𝒋𝒆𝒔𝒕 𝑷𝒓𝒂𝒃𝒊𝒕𝒉 𝑮𝑺 😊" : null}
        </div>
        </div>
        <div>
          {languageSet === "en"
            ? "𝓒𝓱𝓸𝓸𝓼𝓮 𝓹𝓻𝓸𝓹𝓮𝓻 𝓺𝓾𝓪𝓵𝓲𝓽𝔂 𝓯𝓸𝓻 𝓫𝓮𝓼𝓽 𝓹𝓮𝓻𝓯𝓸𝓻𝓶𝓪𝓷𝓬𝓮 ☝️"
            : null}
          {languageSet === "pl"
            ? "𝔀𝔂𝓫𝓲𝓮𝓻𝔃 𝓳𝓪𝓴𝓸ść 𝓰𝓻𝓪𝓯𝓲𝓴𝓲 𝓭𝓵𝓪 𝓷𝓪𝓳𝓵𝓮𝓹𝓼𝔃𝓮𝓳 𝔀𝔂𝓭𝓪𝓳𝓷𝓸ś𝓬𝓲 ☝️"
            : null}<br></br><br></br><br></br>
          {languageSet === "en" ? "Scroll Down slowly to explore 🔽/🖱️" : null}
          {languageSet === "pl" ? "przewiń w dół, aby zbadać 🔽/🖱️" : null}
        </div>
      </div>
      {scrollDownInfo ? (
        <div id="downTextScroll">
          {languageSet === "en" ? "SCROLL TO DISCOVER" : null}
          {languageSet === "pl" ? "SCROLLUJ BY ZOBACZYĆ ZAWARTOŚĆ" : null}
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    languageSet: state.lang.languageSet,
  };
};

export default connect(mapStateToProps)(React.memo(StartInfo));
